import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Pagination, SIZE as paginationSize } from 'baseui/pagination'
import { mergeOverrides } from 'baseui'
import { SDPaginatorOverrides } from './styled-components'

const SDPaginator = ({ overrides, ...rest }) => {
  const { t } = useTranslation()
  const newOverrides = mergeOverrides(SDPaginatorOverrides(), overrides)
  const labels = {
    prevButton: t('common:previous'),
    nextButton: t('common:next'),
    preposition: t('common:pagination_of'),
  }

  return <Pagination labels={labels} {...rest} size={paginationSize.mini} overrides={newOverrides} />
}

SDPaginator.propTypes = {
  overrides: PropTypes.object,
}

export default SDPaginator
